var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiveAccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.518 65.135H8.738a3.977 3.977 0 01-3.972-3.972V15.886h66.723v45.277a3.977 3.977 0 01-3.971 3.972m0-60.37a3.977 3.977 0 013.971 3.973v2.383H4.766V8.738a3.977 3.977 0 013.972-3.972h58.78zM8.738 0C3.918 0 0 3.918 0 8.738v52.425c0 4.82 3.918 8.738 8.738 8.738h58.78c4.82 0 8.737-3.918 8.737-8.738V8.738c0-4.82-3.917-8.738-8.737-8.738H8.738z",
    fill: "#195477"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.24 34.497a1.419 1.419 0 00-2.007-.053l-9.058 8.59-4.32-4.436a1.418 1.418 0 10-2.034 1.98l5.298 5.439a1.418 1.418 0 001.993.04l10.074-9.554c.569-.54.593-1.438.053-2.006",
    stroke: "#F88801",
    fill: "#F88801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 54.912c-8.085 0-14.662-6.577-14.662-14.662S30.415 25.588 38.5 25.588s14.662 6.577 14.662 14.662S46.585 54.912 38.5 54.912m0-32.162c-9.65 0-17.5 7.85-17.5 17.5s7.85 17.5 17.5 17.5S56 49.9 56 40.25s-7.85-17.5-17.5-17.5",
    stroke: "#195477",
    fill: "#195477"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveAccessIcon);
export default __webpack_public_path__ + "static/media/give-access-icon.cf23c017.svg";
export { ForwardRef as ReactComponent };